var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('em',_vm._g(_vm._b({class:(_vm.type + "-" + _vm.name),style:(_vm.style)},'em',_vm.$attrs,false),_vm.$listeners))}
var staticRenderFns = []

export { render, staticRenderFns }